<template>
    <div>
        <v-quagga :onDetected="logIt"
                  :readerTypes="['code_39_reader','code_39_vin_reader','code_128_reader','code_93_reader']"
                  :readerSize="readerSize"
        ></v-quagga>
    </div>
    <!--    <h1>{{ text }}</h1>-->
</template>

<script>
    import EventBus from '@/EventBus'

    export default {
        name: "BarcodeScan",
        data() {
            return {
                detecteds: [],
                readerSize: {
                    width: 200,
                    height: 200
                },
                text: ''
            }
        },
        mounted() {
            window.scrollTo(0, 0)
            EventBus.$emit('set_navigation', {title: 'BARCODE SCAN', back_route: 'search-parcel'})
        },
        methods: {
            logIt(data) {
                // this.text = data.codeResult.code
                // alert(data.codeResult.code)
                console.log('detected', data)

                let parcel = this.getLocalItem();
                parcel.searchText = data.codeResult.code
                localStorage.setItem('parcel', JSON.stringify(parcel))

                return this.$router.push({name: 'parcel-list'})
            }

        }
    }
</script>

<style scoped>

</style>
